import { createComponentsFromChemistryBase } from '@adornis/chemistry/elements/x-components';

// imports for global setttings
import '@adornis/buildify/client/components/x-buildify-global-settings.js';
// imports for main components
import '@adornis/buildify/client/editors/x-buildify-inline-editor.js';
import '@adornis/buildify/client/x-buildify-dropzone.js';
import '@adornis/buildify/client/x-buildify-page.js';
import '@adornis/buildify/client/x-buildify-toolbar.js';
import '@adornis/buildify/client/x-buildify-visualization.js';
import '@adornis/buildify/client/x-buildify.js';
import '@adornis/digitale-helden-shared/client/theme/buildify';
// imports for components
import '@adornis/buildify/client/components/x-buildify-aspect-ratio-picker.js';
import '@adornis/buildify/client/components/x-buildify-border-picker.js';
import '@adornis/buildify/client/components/x-buildify-border-radius-picker.js';
import '@adornis/buildify/client/components/x-buildify-color-picker.js';
import '@adornis/buildify/client/components/x-buildify-drawer-wrapper.js';
import '@adornis/buildify/client/components/x-buildify-file-selection.js';
import '@adornis/buildify/client/components/x-buildify-page-settings.js';
import '@adornis/buildify/client/components/x-buildify-permission-selection.js';
import '@adornis/buildify/client/components/x-buildify-spacing-picker.js';
import '@adornis/buildify/client/components/x-buildify-width-picker.js';
import '@adornis/buildify/client/components/x-icon-button.js';
import '@adornis/buildify/client/components/x-infobox.js';
import '@adornis/buildify/client/extensions/ContainerFlexExtension.js';
import '@adornis/buildify/client/extensions/ContainerGridExtension.js';
import '@adornis/buildify/client/extensions/CustomContentExtension';
import '@adornis/buildify/client/extensions/TextExtension.js';
import '@adornis/buildify/client/extensions/x-extension-editor.js';
import '@adornis/digitale-helden-shared/client/theme/buildify/extensions';
import './d-buildify-visualization.js';

createComponentsFromChemistryBase(
  // 'x-buildify-global-settings',
  'x-buildify-global-settings-color-picker',
  'x-buildify-global-settings-spacing-picker',
  'x-buildify-global-settings-border-radius-picker',
  'x-buildify-global-settings-border-picker',
  'x-buildify-global-settings-width-picker',
  'x-buildify-global-settings-base-templates',
  // main components
  'x-buildify-inline-editor',
  'x-buildify-dropzone',
  // 'x-buildify-visualization',
  'x-buildify-page',
  'x-extension-editor',
  'x-buildify-default-editor',

  // components
  'x-buildify-aspect-ratio-picker',
  'x-buildify-border-radius-picker',
  'x-buildify-border-picker',
  'x-buildify-width-picker',
  'x-buildify-color-picker',
  'x-buildify-file-selection',
  'x-buildify-page-settings',
  'x-buildify-permission-selection',
  'x-buildify-spacing-picker',
  'x-icon-button',
  'x-infobox',
  'x-buildify-color-picker-dropdown-content',

  // buildify extensions
  'x-accordeon-extension',
  'x-icon-text-extension',
  'x-spacing-extension',
  //   'x-section-extension',
  // 'x-tag-extension',
  'x-text-extension',
  //   'x-vimeo-extension',
  //   'x-youtube-extension',
  'x-image-extension',
  'x-container-grid-extension',
  'x-container-flex-extension',

  'x-custom-content-toolbar-items',
);
